import { render } from "./ConversationMessageList.vue?vue&type=template&id=dd67d820&scoped=true"
import script from "./ConversationMessageList.vue?vue&type=script&lang=js"
export * from "./ConversationMessageList.vue?vue&type=script&lang=js"

import "./ConversationMessageList.vue?vue&type=style&index=0&id=dd67d820&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd67d820"

export default script